export default {
  id: 'Log',
  code: 'CN',
  text: {
    'Activity Log': '操作记录',
  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/Logs/locale.js